import { baseURL } from "../../utils/misc";


 export const getBMR_BMRAttachmentsByBMRId = async (token, bMRId) => {
  const requestOptions = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  // Return the fetch Promise
  return await fetch(`${baseURL}/bmr-attachments/BMR/${bMRId}`, requestOptions)
    .then((response) => { 
      if (!response.ok) {
        return;
      }
      return response.json();
    })
    .then((data) => {
      return data; // Return the data as a resolved value
    })
    .catch((error) => {
      console.error("Error fetching BMR Certificate of Release record!", error);
      throw error; // Rethrow the error to propagate it to the caller
    });
};
